import { render, staticRenderFns } from "./RevViewWrapper.vue?vue&type=template&id=25004361&scoped=true"
import script from "./RevViewWrapper.vue?vue&type=script&lang=js"
export * from "./RevViewWrapper.vue?vue&type=script&lang=js"
import style0 from "./RevViewWrapper.vue?vue&type=style&index=0&id=25004361&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25004361",
  null
  
)

export default component.exports